import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '../components/common/SvgIcon';
class StepHeader extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(e) {
    e.preventDefault();
    if (this.props.onClick) {
      this.props.onClick();
    }
  }
  render() {
    return (
      <div className="c-step-header" id={this.props.id ? this.props.id : ''}>
        {this.props.showheaderCrumbs ? (
          <p className="c-step-header__crumbs">
            <a
              className="c-step-header__link"
              data-test-id="back-button"
              href="javascript:void(0)"
              onClick={this.handleClick}
            >
              <span
                className="icon icon-page-back c-step-header__linkicon"
                aria-hidden="true"
                role="img"
              />
              <span className="c-step-header__linktext">
                {this.props.headerCrumbsMessage}
              </span>
            </a>
          </p>
        ) : null}
        <h2
          className="c-step-header__title"
          data-test-id="edit-pageheader-title"
        >
          {this.props.headerTitle}
        </h2>
        {this.props.headerSubtitle ? (
          <p className="c-step-header__subtitle">{this.props.headerSubtitle}</p>
        ) : null}
        {this.props.headerSubtext ? (
          <p className="c-step-header__subtext">{this.props.headerSubtext}</p>
        ) : null}
        {this.props.showControl ? (
          <div className="c-step-header__controls">
            <button
              className="c-btn c-btn--link c-btn--link-icon c-step-header__control"
              onClick={this.props.controlBack}
            >
              <span className="u-visually-hidden off-screen">Previous</span>
              <span className="icon-swipe-left" aria-hidden="true" />
            </button>
            <button
              className="c-btn c-btn--link c-btn--link-icon c-step-header__control"
              onClick={this.props.controlForward}
            >
              <span className="u-visually-hidden off-screen">Next</span>
              <span className="icon-swipe-right" aria-hidden="true" />
            </button>
            <button
              className="refresh-btn c-btn c-btn--link c-btn--link-icon c-step-header__control"
              onClick={this.props.controlRefresh}
            >
              <SvgIcon id="icon-refresh-large" width="24px" height="24px" />
              <span className="u-visually-hidden off-screen">Refresh</span>
            </button>
          </div>
        ) : null}
      </div>
    );
  }
}
StepHeader.propTypes = {
  onClick: PropTypes.func,
  headerSubtitle: PropTypes.string,
  headerSubtext: PropTypes.string,
  headerTitle: PropTypes.string,
  headerCrumbsMessage: PropTypes.string,
  showheaderCrumbs: PropTypes.bool,
  showControl: PropTypes.bool,
};

StepHeader.defaultProps = {
  showheaderCrumbs: false,
  showControl: false,
};
export default StepHeader;
